var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70502 0.39209C3.84102 0.39209 0.705017 3.52809 0.705017 7.39209C0.705017 11.2561 3.84102 14.3921 7.70502 14.3921C11.569 14.3921 14.705 11.2561 14.705 7.39209C14.705 3.52809 11.569 0.39209 7.70502 0.39209ZM6.30502 10.8921L2.80502 7.39209L3.79202 6.40509L6.30502 8.91109L11.618 3.59809L12.605 4.59209L6.30502 10.8921Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.f15d5be111b692c42a0c93737b7abbfa.svg";
export { ForwardRef as ReactComponent };